import { useBetOnRacer } from '@/ui/hooks/useBetOnRacer';
import { Minimap } from './MiniMap/MiniMap';
import { Emojis } from './Emojis/Emojis';
import { SentEmojis } from './SentEmojis/SentEmojis';
import './racing.css';

export const Racing = () => {
    const betOnRacer = useBetOnRacer();

    return (
        <div className="racing">
            <SentEmojis />

            {!betOnRacer ? (
                <div className="racing__round-status">
                    <h1 className="racing__round-status-title">This round is closed</h1>
                    <h2 className="racing__round-status-subtitle">
                        Please wait for the next round
                    </h2>
                </div>
            ) : (
                <div className="racing__racer-status">
                    <div className="racing__racer-position">{betOnRacer.position}</div>
                    {/* TODO removed as there is no time data
                    <div className="racing__timer">
                        <span className="racing__timer-value">{betOnRacer.time}</span>
                        <Icon className="racing__timer-icon" src={timeIcon} />
                    </div> */}
                </div>
            )}

            <Minimap />

            {betOnRacer && <Emojis forRacer={betOnRacer.racerId.toLowerCase()} />}
        </div>
    );
};
